import { render, staticRenderFns } from "./TrafficChart.vue?vue&type=template&id=ca29db62&scoped=true"
import script from "./TrafficChart.vue?vue&type=script&lang=js"
export * from "./TrafficChart.vue?vue&type=script&lang=js"
import style0 from "./TrafficChart.vue?vue&type=style&index=0&id=ca29db62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca29db62",
  null
  
)

export default component.exports